import { LoadingButton } from "@mui/lab";
import { Card, Grid } from "@mui/material";
import { Box, styled, useTheme } from "@mui/system";
import { Field, Formik } from "formik";
import { useMemo, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { RegexUsername } from "../../../../configs/regex";
import {
  InputPassword,
  InputText,
  Paragraph,
  setTitleCase,
} from "../../../components/template/partials";
import { useAuthUIContext } from "../AuthUIContext";

// HOOKS
import useAuth from "../../../hooks/useAuth";

const FlexBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));
const JustifyBox = styled(FlexBox)(() => ({ justifyContent: "center" }));
const ContentBox = styled(Box)(() => ({
  height: "100%",
  padding: "32px",
  position: "relative",
  background: "rgba(0, 0, 0, 0.01)",
  borderColor: "primary.main",
}));

// inital login credentials
const initialValues = (autocomplete) => {
  return {
    username: autocomplete?.username ?? "",
    password: "",
    // remember: false,
  };
};

// form field validation schema
const validationSchema = Yup.object().shape({
  username: Yup.string()
    .required("Nama Pengguna wajib diisi!")
    .matches(RegexUsername, "Format Nama Pengguna tidak sesuai"),
  password: Yup.string().required("Kata Sandi wajib diisi!"),
});

export function SignInPage() {
  const authUIContext = useAuthUIContext();
  const authUIProps = useMemo(() => {
    return {
      signUpData: authUIContext.signUpData,
    };
  }, [authUIContext]);
  const { signUpData } = authUIProps;
  const theme = useTheme();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const { signIn } = useAuth();

  const handleFormSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await signIn(values);
      navigate("/dashboard");
      toast.success(
        setTitleCase(`selamat datang, ${response.data?.nama_lengkap}!`)
      );
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
  };

  return (
    <Card className="auth-content-card-border">
      <Grid container>
        <Grid item sm={6} xs={12}>
          <JustifyBox p={4} height="100%" sx={{ minWidth: 320 }}>
            <img
              src="/assets/images/bg-form-auth.webp"
              width="100%"
              height="100%"
              alt="sign-in images"
              loading="lazy"
            />
          </JustifyBox>
        </Grid>
        <Grid item sm={6} xs={12}>
          <ContentBox>
            <Formik
              enableReinitialize
              onSubmit={handleFormSubmit}
              initialValues={initialValues(signUpData)}
              validationSchema={validationSchema}
            >
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Field
                    component={InputText}
                    name="username"
                    label="Nama Pengguna"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                    sx={{ mb: 3 }}
                  />

                  <Field
                    component={InputPassword}
                    name="password"
                    label="Kata Sandi"
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 1.5 }}
                  />

                  {/* <FlexBox justifyContent="space-between">
                        <FlexBox gap={1}>
                          <Checkbox
                            size="small"
                            name="remember"
                            onChange={handleChange}
                            checked={values.remember}
                            sx={{ padding: 0 }}
                          />

                          <Paragraph>Remember Me</Paragraph>
                        </FlexBox>

                        <NavLink
                          to="/session/forgot-password"
                          style={{ color: theme.palette.primary.main }}
                        >
                          Forgot password?
                        </NavLink>
                      </FlexBox> */}

                  <LoadingButton
                    type="submit"
                    color="primary"
                    loading={isLoading}
                    variant="contained"
                    sx={{ my: 2 }}
                  >
                    Masuk
                  </LoadingButton>

                  <Paragraph>
                    Belum punya akun?
                    <NavLink
                      to="/auth/sign-up"
                      style={{
                        color: theme.palette.primary.main,
                        marginLeft: 5,
                      }}
                    >
                      Halaman Daftar
                    </NavLink>
                  </Paragraph>
                </form>
              )}
            </Formik>
          </ContentBox>
        </Grid>
      </Grid>
    </Card>
  );
}
